export const BASE_URL = 'https://agentnetwork.co.in/api';
//export const BASE_URL = 'http://localhost:3000/api';

export const IMAGE_PATH = 'https://agentnetwork.co.in/';
//export const IMAGE_PATH = 'http://localhost:3000/';

export const WEBSOCKET_URL = 'https://agentnetwork.co.in';
//export const WEBSOCKET_URL = 'http://localhost:3000';

export const API_VERSION = 'v1';


export const _JET_BLACK = "#111111";
export const _BLACK = "#000000";

export const _ARCTIC_WHITE = "#F5F5F5";
export const _PEARL_WHITE = "#F8F8FF";
export const _RUBY_RED = "#F40009";
export const _BRIGHT_YELLOW = "#F8E823";
export const _FOREST_GREEN = "#228B22";
export const _ROYAL_BLUE = "#004A97";
export const _AZURE_BLUE = "#0071C5";
export const _TEAL_BLUE = "#0b648f";
export const _PLUM_PURPLE = "#7B0099";
export const _VIVID_PURPLE = "#7B0099";
export const _GRAPE_PURPLE = "#702082";
export const _LAVENDER_PURPLE = "#9370DB";
  



export const API_ENDPOINTS = {
  USERS: '/users',
  POSTS: '/posts',
  // Add more endpoints as needed
};